import { faCommentAlt, faThumbsUp } from "@fortawesome/free-solid-svg-icons"
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function ModuleCard(props){
    const history = useHistory()
    const placeHolderImg = (e) =>{
        e.target.src = "/placeHolder.png"
    }
    const { id, thumbnail, authors, upvotesCount, commentsCount } = props.module

    const handleOnClick = () => {
        history.push(`/module/${id}`);
    }

    return (  
        <div className="gameCard" onClick={handleOnClick}>
            <img src={thumbnail ?? "/placeHolder.png"} onError={placeHolderImg} loading="lazy" className="gameImage" alt={id}/>
            <div className="cardInfo">
                <h2 className="gameTitle">{id}</h2>
                {/* <h3 className="gameAuthor">made by <span className="authorName">{authors ?? "Unknown"}</span></h3> */}
                <h3 className="gameAuthor">made by Unknown</h3>
                <span>
                    <span className='mr-2'><FontAwesomeIcon style={{color: 'red'}} icon={faThumbsUp} />{upvotesCount ?? 0} </span>
                    <span><FontAwesomeIcon style={{color: 'blue'}} icon={faCommentAlt} />{commentsCount ?? 0}</span>
                </span>
            </div>
        </div>
    )
}

export default ModuleCard